import { useWidgetPageListApi } from '@/common/api/modules/widgetPage'
import { useFirstLoading } from '@/common/api/search'
import { widgetPageNewPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'

import Button, { ButtonColor } from '@/components/view/atoms/button/Button'
import Text from '@/components/view/atoms/text/Text'
import Area from '@/components/view/layouts/area/Area'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageListLoading from '@/components/view/molecules/loading/PageListLoading'
import NoResultGuidance from '@/components/view/molecules/search/NoResultGuidance'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import AppTitleBadge from '@/components/container/layout/AppTitleBadge'
import WidgetPageListTable from '@/components/container/modules/recommend/widgetPage/table/WidgetPageListTable'

const WidgetPageListPage = () => {
  const siteId = useSiteId()
  const { data, isLoading, mutate } = useWidgetPageListApi({ site_id: siteId })
  const isFirstLoading = useFirstLoading(isLoading)

  return (
    <Main type={MainLayoutType.SMALL} bottomSpace>
      <PageTitle
        title={'レコメンドパーツ設置ページ一覧'}
        rightNode={
          <Button link={widgetPageNewPath(siteId)} size='large' color={ButtonColor.PRIMARY_BRAND}>
            設置ページの新規追加
          </Button>
        }
        behindNode={data && <Text size={12}>{data.length}件</Text>}
        badgeNode={<AppTitleBadge type='recommend' />}
      />
      <Content>
        {isFirstLoading ? (
          <Area tableWrap noBorder>
            <PageListLoading />
          </Area>
        ) : data && data.length > 0 ? (
          <WidgetPageListTable widgetPages={data} onRefresh={mutate} />
        ) : (
          <Area tableWrap noBorder>
            <NoResultGuidance name='設置ページ' />
          </Area>
        )}
      </Content>
    </Main>
  )
}

export default WidgetPageListPage
